import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'nb-modal-header',
  templateUrl: './nb-modal-header.component.html',
  styleUrls: ['./nb-modal-header.component.scss'],
})
export class NbModalHeaderComponent {
  @Input()
  title: string;

  @Output()
  close = new EventEmitter<void>();

  constructor() {}

  onCloseClicked() {
    this.close.emit();
  }
}
